/* eslint-disable max-len */
/* eslint-disable react/display-name */
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { Arr } from '../../CodesForFoundation';
import { AccountModel } from '../account/AccountModel';
import { AppEvents } from '../AppEvents';
import { BoardModel, FolderModel, ModelBroker } from '../dashboard/Models';
import { PassportModel } from '../PassportModel';
import { createScope } from '../Scope';
import { TemplateLibraryModel } from './TemplateLibraryModels';

// const onFolderCreate = (model:TemplateLibraryModel) => ({ folder }: AppEventStreams['folder:create']) => {

//     const fd = broker.allocate(FolderModel, { ...e.folder, boards: [] });
//     const ws = broker.get(WorkspaceModel, fd.workspaceId);
//     ws?.mutate(x => x.folders.push(fd));
// };

// const onFolderPatch = (broker: ModelBroker) => (e: AppEventStreams['folder:patch']) => {
//     const fd = broker.get(FolderModel, e.folder.id);
//     if (!fd) return;
//     fd.mutate(x => Object.assign(x, e.folder));
// };

// const onFolderDelete = (broker: ModelBroker, location: AppLocation, navigator: Navigator) => (e: AppEventStreams['folder:delete']) => {
//     const fd = broker.get(FolderModel, e.folderId);
//     if (!fd) return;
//     const ws = broker.get(WorkspaceModel, fd.workspaceId);
//     if (!ws) return;
//     // Move boards to workspace and remove folder from workspace
//     ws.mutate(s => {
//         Arr.remove(s.folders, fd);
//         s.boards.push(...fd.boards);
//     });
//     // Redirect navigator if we are in location of folder
//     if (location.includes('folder', fd.id)) {
//         navigator.go(`~/${ws.id}`);
//     }
// };

export const TemplateLibraryScope = createScope({
    // shouldRefresh(p, c) {
    //     const m = c.get(WorkspaceModel);
    //     return m.id !== p.entityId && !m.findFolder(p.entityId);
    // },
    async refresh(p, c) {

        const account = c.get(AccountModel);
        const api = c.get(ApiClient);
        const evts = c.get(AppEvents);
        const broker = c.get(ModelBroker);

        const data = await api.exec(v2.templates.list());
        const [model, updateModel] = TemplateLibraryModel.create(account, broker, data);
        c.bind(TemplateLibraryModel).toConstantValue(model);

        const permissionsData = await api.exec(v2.me.permissions(['workspace', model.workspaceId]));
        c.bind(PassportModel).toConstantValue(PassportModel.create(permissionsData));

        return [
            //
            // Folder events
            evts.on('board:create', ({ board }) => {
                const f = model.folders.find(x => x.id === board.folderId);
                f?.mutate(x => x.boards.push(broker.allocate(BoardModel, board)));
            }),
            evts.on('board:delete', ({ boardId }) => {
                for (const f of model.folders) {
                    f.mutate(x => Arr.removeWhere(x.boards, b => b.id === boardId));
                }
            }),
            evts.on('board:patch', ({ board }) => {
                broker.get(BoardModel, board.id)?.mutate(board);
            }),
            //
            // Folder events
            evts.on('folder:create', ({ folder }) => updateModel(({ folders }) => {
                if (folder.workspaceId !== model.workspaceId) return;
                Arr.addIfNotMatch(folders, broker.allocate(FolderModel, folder), x => x.id === folder.id);
            })),
            evts.on('folder:patch', ({ folder }) => {
                broker.get(FolderModel, folder.id)?.mutate(folder);
            }),
            evts.on('folder:delete', ({ folderId }) => updateModel(({ folders }) => {
                Arr.removeWhere(folders, f => f.id === folderId);
            })),
        ];
    }
});

